import {getInitialSite, siteId} from "./map/site_management";
import mapboxgl from "mapbox-gl";
import Config from "./config/constants";
import MapConfig from "./config/map_config";
import {createExceptionRow, fitMapToBounds, geofenceAjaxCall, imageDataAjaxCall, machineZoneAjaxCall, tunnelAjaxCall} from "./map/map_ajax";
import {addPolygonsMouseOver} from "./map/map";
import Swal from 'sweetalert2';
import Chart from 'chart.js/auto'
import addSeconds from 'date-fns/addSeconds'
import format from 'date-fns/format'
import isValid from 'date-fns/isValid'
import parse from 'date-fns/parse'
import parseISO from 'date-fns/parseISO'
import intervalToDuration from 'date-fns/intervalToDuration'
import videojs from "video.js";
import AWS from "aws-sdk";

$(document).on('turbolinks:load', () => {
    let machines_switch = $("#machines_switch");
    if(machines_switch.length) {
        listenForSwitch(machines_switch);
        listenForExpand();
        listenForCheckbox();
        listenForMapClick();
        listenForEditClick();
        listenForLocationClick();
    }

    if ($('#assign_machines_map').length) {
        $.when(getInitialSite()).done(() => {
            initiateAssignMachinesMap();
        })
    }

    if($('#machines-events-table').length) {
        listenForEventRowClick();
        listenForOverallHeaderClick();
    }

    if($('#doughnut_canvas').length) {
        generateOverallDoughnutChart();
    }

    if($('#line_chart_canvas').length) {
        generateSpecificMachineLineChart();
    }
});

function initiateAssignMachinesMap() {
    const siteId = document.getElementById("site_id").value;
    const siteCoordinates = document.getElementById("site_coordinates").value;
    const geofenceIds = document.getElementById("geofence_ids").value;
    mapboxgl.accessToken = Config.mapboxAccessToken;
    const map = new mapboxgl.Map({
        container: 'assign_machines_map',
        style: MapConfig.regularStyle,
        center: siteCoordinates.split(" "),
        zoom: MapConfig.startingZoom,
        minZoom: MapConfig.zoomOutMax,
        maxZoom: MapConfig.zoomInMax
    });
    fitMapToBounds(map, siteId, siteCoordinates);

    map.on('load', () => {
        listenForAddCurrentMachines();
        listenForDoneAssigning();
        listenForMachinesList();
        let is_type_search = $("#is_type_search").val();
        let type = $("#type").val();
        let machine_ids = $("#machine_ids").val().split(",");

        imageDataAjaxCall(map, null, null, null, false, true, true, false, null, siteId, null, false, false, true).then(
            response => machineZoneAjaxCall(
                map,
                null,
                geofenceIds,
                true,
                false,
                false,
                is_type_search,
                type,
                machine_ids
            )
        )
        addPolygonsMouseOver(map, 'machine_zones');
    });
}

function listenForAddCurrentMachines() {
    $("#machines-popout-add-machines").on('click', function() {
        Swal.fire({
            title: 'Add machines to zone',
            text: "Are you sure you want to add the selected machines to this zone?",
            icon: 'info',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                let is_type_search = $("#is_type_search").val();
                let type = $("#type").val();
                let machine_ids = $("#machine_ids").val().split(",");
                let geofence_id = $("#machines-popout-add-machines").data('geofence_id');
                let geofence_name = $("#popout-zone-name").val();
                let exceptionsContainer = document.getElementById('exceptions-container');
                let exceptionsList = document.getElementById('exceptions-list-body');
                $.ajax({
                    type: 'POST',
                    url: `${Config.apiUrl}internal_machines/update_machines_zone_access?apikey=${Config.apiKey}&is_type_search=${is_type_search}&type=${type}&machine_ids=${machine_ids}&machine_zone_id=${geofence_id}`,
                    dataType: "json",
                    success: function() {
                        Swal.fire("Done!", "Machines Added!", "success").then((done) => {
                            exceptionsContainer.style.display = "block";
                            if (is_type_search && is_type_search == "true"){
                                createExceptionRow(type, geofence_id, geofence_name, false, exceptionsList);
                            }
                            for (let i = 0; i < machine_ids.length; i++) {
                                if (machine_ids[i] == '') {
                                    continue;
                                }
                                createExceptionRow(machine_ids[i], geofence_id, geofence_name, false, exceptionsList);
                            }
                        })
                    },
                    error: function() {
                        Swal.fire('There was a problem adding the selected machines to the zone.')
                    }
                });
            } else {
                Swal.fire('Machines not added.')
            }
        })
    });
}

function listenForMachinesList() {
    $("#expand-machines-list").on("click", function() {
        let machines_list = $(".machines-list");
        if(machines_list.is(":visible")) {
            machines_list.hide();
        }else{
            machines_list.show();
        }
    })
}

function listenForCheckbox() {
    let machine_select = $(".machines-hidden-select");
    let machines_with_type = $("#machines_with_type").val();
    let is_type_search = $("#is_type_search");
    let add_to_zones_button = $("#add-machines-to-zones-button");

    $(".select-all-machines-checkbox").on("click", function() {
        if($(this).is(':checked')) {
            $('.machines-checkbox').trigger('click')
        }else {
            $('.machines-checkbox').trigger('click')
        }
    })

    $(".machines-checkbox").on("click", function() {
        let select_string = ".machines-hidden-select option[value=" + $.escapeSelector($(this).attr('checked_value')) + "]"
        if($(this).is(':checked')) {
            $(select_string).prop('selected', true);
        }else{
            $(select_string).prop("selected", false);
        }

        if(machine_select.val().length) {
            add_to_zones_button.prop('disabled', false);
            add_to_zones_button.removeClass('is-disabled');
        }else{
            add_to_zones_button.prop('disabled', true);
            add_to_zones_button.addClass('is-disabled');
        }
    })
}

function listenForDoneAssigning() {
    $("#assign-machines-done").on("click", function() {
        Swal.fire({
            title: 'Finished?',
            text: "Do you want to return to the machines screen?",
            icon: 'info',
            showCancelButton: true,
        }).then((result) => {
            if(result.isConfirmed) {
                let url = window.location.href;
                url = window.location.origin + '/machines'
                window.location.replace(url);
            }
        })
    })
}

function listenForLocationClick () {
    $(".latest-machine-box").on("click", function () {
        let machine_id = $(this).data('machine-id');

        $.ajax({
            type: 'GET',
            url: `${Config.apiUrl}internal_machines/get_machine_details?apikey=${Config.apiKey}`,
            data: {
                machine_id: machine_id
            },
            success: data => {
                if (data.date_from && data.fleet_number){
                    window.location.replace(window.location.origin + `/map?date_from=${data.date_from}&date_to=${data.date_to}&site_id=${data.site_id}&machines=${data.fleet_number}&latitude=${data.latest_latitude}&longitude=${data.latest_longitude}`)
                }
            }
        });
    })
}

function listenForExpand() {
    $(".expand-machine").on("click", function() {
        let machine_id = $(this).data('machine-id');

        $.ajax({
            type: 'GET',
            url: `${Config.apiUrl}internal_machines/get_machine_details?apikey=${Config.apiKey}`,
            data: {
                machine_id: machine_id
            },
            success: data => {
                $("#actions-" + machine_id + "  .machine_sense_id").text(data.machine_sense_id);
                $("#actions-" + machine_id + "  .installed_at").text(data.installed_at);
                $("#actions-" + machine_id + "  .uninstalled_at").text(data.uninstalled_at);
                if (data.date_from && data.fleet_number) {
                    $(".latest-machine-box").removeClass('is-disabled')
                } else {
                    $(".latest-machine-box").addClass('is-disabled');
                }
            }
        });

        let hidden_row = $("#actions-" + machine_id);
        if(hidden_row.is(":visible")){
            $(".actions-row").hide();
        } else {
            $(".actions-row").hide();
            hidden_row.fadeIn();
        }
    })
}

function listenForSwitch(machines_switch) {
    let machines_form = $("#machines-form");
    let type_form = $("#type-form");
    machines_switch.change(function() {
        if(this.checked) {
            machines_form.hide();
            type_form.show();
        }else{
            machines_form.show();
            type_form.hide();
        }
    })
}

function listenForMapClick() {
    $("#preview_map_machines").on("click", function() {
        let overlay = $("#machines_preview_overlay");
        overlay.show();
        overlay.fadeOut(5000);
    })
}

function listenForEditClick() {
    $(".edit-machine").on("click", function () {
        let machine_id = $(this).data('machine-id');
        let worker_select = $(".worker_select_div_" + machine_id);
        let edit_machine_label = $(".edit-machine-label." + machine_id);
        let edit_machine_stat = $(".edit-machine-stat." + machine_id);
        let description_box = $(".machine-description-column." + machine_id);

        if ($(this).data('is-save')) {
            Swal.fire({
                title: 'Save Machine',
                text: "Are you sure to save these machine details?",
                icon: 'info',
                showCancelButton: true,
            }).then((value) => {
                if (value) {
                    let description = $("#description.machine-input." + machine_id).val();
                    let speed_limit = $("#speed_limit.machine-input." + machine_id).val();
                    let machine_idle = $("#idle.machine-input." + machine_id).val();

                    $.ajax({
                        type: 'POST',
                        url: `${Config.apiUrl}internal_machines/save_machine_details?apikey=${Config.apiKey}`,
                        data: {
                            machine_id: machine_id,
                            description: description,
                            speed_limit: speed_limit,
                            machine_idle: machine_idle
                        },
                        success: data => {
                            Swal.fire("Done!", "Machine Saved!", "success")

                            $(".data-box__stat.description." + machine_id).text(description);
                            $(".data-box__stat." + machine_id).show();
                            $(".machine-input." + machine_id).hide();
                            $(".machine-description-td." + machine_id).text(description);
                            $(".data-box__stat.speed_limit." + machine_id).text(speed_limit + " mph");
                            $(".data-box__stat.idle." + machine_id).text(data.idle_pretty);
                            edit_machine_stat.show();
                            edit_machine_label.html('Edit Machine');
                            edit_machine_stat.html('<i class="fas fa-edit"></i> Edit');
                            worker_select.hide();
                            $(this).data('is-save', false);
                        },
                        error: data => {
                            Swal.fire("Error trying to save machine");
                        }
                    })
                }
            })
        } else {
            $(".data-box__stat." + machine_id).hide();
            $(".machine-input." + machine_id).show();
            edit_machine_stat.show();
            edit_machine_label.html('Save Machine');
            edit_machine_stat.html('<i class="fas fa-check"></i> Save');
            worker_select.show();
            $(this).data('is-save', true);
        }
    })
}

function listenForOverallHeaderClick() {
    $(".overall_table_header").on("click", function () {
        window.location = $(this).data("link")
    })
}

function listenForEventRowClick() {
    $(".overall_event_data_row").on("click", function () {
        window.location = $(this).data("link")
    })

    $(".machine_event_data_row").on("click", function () {
        let machine_id = $(this).data('machine-id');
        let selected_date = $(this).find('#event_row_date').html().trim();
        let hidden_row = $(`#graphs-${machine_id}-${selected_date}`);
        let graph_id = `graph-${machine_id}-${selected_date}`

        if(hidden_row.is(":visible")){
            $(".machine_event_graph_row").hide();
        } else {
            $(".machine_event_graph_row").hide();
            hidden_row.fadeIn();

            $.ajax({
                type: 'GET',
                url: `${Config.apiUrl}internal_machines/daily_activity_chart?apikey=${Config.apiKey}`,
                data: {
                    machine_id: machine_id,
                    selected_date: $(this).find('#event_row_date').html(),
                },
                success: data => {
                    const chart_data = JSON.parse(data.chart_data);
                    const formatted_from_date = data.from_date;
                    const formatted_to_date = data.to_date;

                    (async function() {
                        let chartStatus = Chart.getChart(graph_id); // <canvas> id
                        if (chartStatus != undefined) {
                            chartStatus.destroy();
                        }

                        const data = chart_data;

                        const tooltip = {
                            callbacks: {
                                label: (context) => {
                                    var texts = []
                                    var title = context.raw.title.split(" - ")[1].trim();
                                    if (title.includes('pending')) {
                                        texts.push(title);
                                    } else {
                                        const { hours, minutes, seconds } = intervalToDuration({ start: new Date(context.raw.x[0]), end: new Date(context.raw.x[1]) });
                                        texts.push(`${hours} hours : ${minutes} minutes : ${seconds} seconds`);
                                        texts.push(title);
                                    }

                                    return texts
                                }
                            }
                        };

                        const scales = {
                            x: {
                                type: 'time',
                                time: {
                                    unit: 'hour'
                                },
                                min: formatted_from_date,
                                max: formatted_to_date,
                            },
                            y: {
                                stacked: true,
                            }
                        };

                        new Chart(
                            graph_id,
                            {
                                type: 'bar',
                                data: data,
                                options: {
                                    indexAxis: 'y',
                                    interaction: {
                                        intersect: false,
                                        mode: 'point',
                                    },
                                    onClick: (event, barElement) => {
                                        if (barElement.length) {
                                            // get the filename of the cctv clip related to the nearest ignition event
                                            let filename = barElement[0].element.$context.raw['filename'];
                                            let is_on_s3 = barElement[0].element.$context.raw['is_on_s3'];
                                            if (filename && is_on_s3){
                                                let time_difference = barElement[0].element.$context.raw['time_difference'];
                                                console.log("time difference: ", time_difference);
                                                playVideoClip(filename, time_difference, barElement[0].element.$context.raw['title']);
                                            } else {
                                                Swal.fire("No CCTV Clip Found", "There was no CCTV clip found for this event.", "error");
                                            }
                                        }
                                    },
                                    plugins: {
                                        tooltip: tooltip,
                                    },
                                    scales: scales,
                                    maintainAspectRatio: false
                                }
                            }
                        );
                    })();
                }
            })
        }
    })
}

function playVideoClip(file_name, time_difference, title) {
    let eventModal = $("#event-video-modal");
    var player = videojs(document.querySelector('.video-js'));

    $.ajax({
        url: `${Config.apiUrl}files/aws_s3_key?apikey=${Config.apiKey}`,
        type: "GET",
        success: async data => {
            var params = {
                Bucket: data.bucket,
                Key: file_name,
            };

            var s3 = new AWS.S3({
                accessKeyId: data.access_key_id,
                secretAccessKey: data.key,
                region: data.region,
            });

            var promise = s3.getSignedUrlPromise('getObject', params);
            promise.then(
                function (url) {
                    player.src({
                        src: url,
                        type: 'video/mp4' /*video type*/,
                    });
                    player.currentTime(time_difference);
                    $('#video-overlay-text').appendTo($('#machine-event-video'));

                    player.on('fullscreenchange', function() {
                        if (player.isFullscreen()) {
                            $("#video-overlay-text").css("font-size", "15em");
                        } else {
                            $("#video-overlay-text").css("font-size", "5em");
                        }
                    });

                    let title_date = title.split(" - ")[1]
                    if (isValid(parseISO(title_date))) {
                        let dt = parse(`${title_date}`, 'yyyy-MM-dd HH:mm:ss', new Date());
                        const current_time_holder = document.getElementById("current_time");
                        clearInterval($('#machine-event-video').data('interval'));

                        if (current_time_holder) {
                            let interval_id = setInterval(function() {
                                let current = player.currentTime();
                                current_time_holder.innerHTML = format(addSeconds(dt, current), 'yyyy-MM-dd HH:mm:ss');
                            }, 400);
                            $('#machine-event-video').data('interval', interval_id);
                        }
                    }
                },
                function (err) {
                    console.log(err);
                }
            );

            //activate modal
            eventModal.addClass("is-active");
            document.getElementById('machine-modal-card-title').innerHTML = title;
        }
    })
}

function generateOverallDoughnutChart() {
    let doughnut_data = JSON.parse(document.getElementById('overall_doughnut_data').value);

    let options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Average Activity For All Machines'
            },
            tooltip: {
                enabled: false
            }
        },
    }

    const hoverLabel = {
        afterDraw(chart, args, options) {
            const { ctx, chartArea: { left, right, top, bottom, width, height } } = chart;
            ctx.save();

            if (chart._active.length) {
                const textLabel = chart.config.data.labels[chart._active[0].index];
                const numLabel = chart.config.data.datasets[chart._active[0].datasetIndex].data[chart._active[0].index]
                const color = chart.config.data.datasets[chart._active[0].datasetIndex].backgroundColor[chart._active[0].index];

                ctx.font = '900 24px Helvetica';
                ctx.textAlign = 'center';
                ctx.fillStyle = color;
                ctx.fillText(`${numLabel}%`, width / 2, height / 2 + top - 5);
                ctx.font = 'bolder 17px Helvetica';
                ctx.fillStyle = 'black';
                ctx.fillText(`${textLabel.toUpperCase()}`, width / 2, height / 2 + top + 18);
            }
            ctx.restore();
        }
    }

    new Chart(
        'doughnut_canvas',
        {
            type: 'doughnut',
            data: {
                labels: ['Active', 'Idle', 'Off'],
                datasets: [
                    {
                        data: doughnut_data,
                        backgroundColor: [
                            'rgba(1,187,1,0.8)',
                            'rgba(0,112,255,0.8)',
                            'rgba(175,175,175,0.8)',
                        ],
                        hoverOffset: 4,
                        cutout: '40%'
                    }
                ]
            },
            options: options,
            plugins: [hoverLabel]
        }
    );
}

function generateSpecificMachineLineChart() {
    let line_active_data = JSON.parse(document.getElementById('line_chart_active_data').value);
    let line_idle_data = JSON.parse(document.getElementById('line_chart_idle_data').value);
    const start_date = document.getElementById('start_date').value;
    const end_date = document.getElementById('end_date').value;

    let datasets = [
        {
            label: 'Active',
            data: line_active_data,
            borderColor: 'rgba(1,187,1,0.8)'
        },
        {
            label: 'Idle',
            data: line_idle_data,
            borderColor: 'rgba(0,112,255,0.8)',
        }
    ];

    const tooltip = {
        yAlign: 'bottom',
        callbacks: {
            title: (context) => {
                return null;
            },
            label: (context) => {
                const { hours, minutes, seconds } = intervalToDuration({ start: 0, end: context.raw.y * 1000 });
                const zeroPad = (num) => String(num).padStart(2, '0')
                return `${zeroPad(hours)} hours : ${zeroPad(minutes)} minutes : ${zeroPad(seconds)} seconds`
            }
        }
    };

    let options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: tooltip,
            title: {
                display: true,
                text: 'Total activity per hour for filtered time period'
            }
        },
        scales: {
            x: {
                type: 'time',
                distribution: 'linear',
                time: {
                    unit: 'hour'
                },
                min: start_date,
                max: end_date,
            },
            y: {
                min: 0,
                ticks: {
                    callback: function(value, index, ticks) {
                        const { hours, minutes, seconds } = intervalToDuration({ start: 0, end: value * 1000 });
                        const zeroPad = (num) => String(num).padStart(2, '0')
                        if (hours > 0) {
                            return `${zeroPad(hours)}h : ${zeroPad(minutes)}m`
                        }
                        return `${zeroPad(minutes)}m`
                    }
                }
            }
        }
    }

    new Chart(
        'line_chart_canvas',
        {
            type: 'line',
            label: 'Activity over time',
            data: {
                datasets: datasets
            },
            options: options
        }
    );
}